import React from 'react';
import { Link } from 'react-router-dom';
import teacherImage from '../assets/coach1.svg'; // Using a placeholder image

const DanceCoach: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="row text-center mb-5">
        <div className="col">
          <h1>Meet Our Dance Instructor</h1>
        </div>
      </div>

      <div className="row mb-5 align-items-center">
        <div className="col-md-4">
          <img src={teacherImage} alt="Dance Teacher" className="img-fluid rounded-circle" />
        </div>
        <div className="col-md-8">
          <h2>Instructor's Name</h2>
          <p>
            Our amazing dance instructor is a passionate and experienced dancer with a love for teaching. 
            With a background in various dance styles, she is dedicated to creating a fun and supportive 
            learning environment for all students. Whether you're a beginner or have some experience, 
            she will help you develop your skills and confidence on the dance floor.
          </p>
        </div>
      </div>

      <div className="row text-center mt-5">
        <div className="col">
          <h2>Ready to Dance?</h2>
          <p>Book your first class today and discover the joy of dancing!</p>
          <Link to="/book/dance-class" className="btn btn-primary btn-lg">Book a Dance Class</Link>
        </div>
      </div>
    </div>
  );
};

export default DanceCoach;
